import {Subscription} from 'rxjs/Subscription';
import { OnDestroy, Inject } from '@angular/core';

export class CuiBaseComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor() {}

  protected pushSubscription(...subscriptions: Subscription[]) {
    subscriptions.forEach(subscription => this.subscriptions.push(subscription));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/shared/base-component.ts